import { createAsyncThunk } from '@reduxjs/toolkit';

import SignInProcessApi from 'api/curo/SignInProcessApi';
import { SignInProcessActionTypes } from 'enums/curo/SignInProcessActionTypes';
import TokenUtils from 'utils/TokenUtils';

export const createVerifySessionThunk = (api: SignInProcessApi) =>
  createAsyncThunk(
    SignInProcessActionTypes.VerifySession,
    async ({ borrowerId }: { borrowerId: string }) => {
      try {
        await api.verifySession(borrowerId);

        return { isSessionVerified: true };
      } catch (error) {
        TokenUtils.removeTokens();
        return { isSessionVerified: false };
      }
    },
  );
